import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Persona } from './models/persona.model';
import { takeUntil } from "rxjs/operators";
import { ScreenDeviceService } from '../../../core/services/Screen/screen-device.service';
import { ITotalPriceResume } from '../../../core/interfaces/ITotalPriceResume.interface';
import { Subject } from 'rxjs';
import { CoverageModalBaseComponent } from '../../../shared/coverage-modal-base/coverage-modal-base.component';
import { MatDialog } from '@angular/material/dialog';
import { AnalyticsService } from '../../../core/services/adobe-analytics/analytics.service';
import { environment } from '../../../../environments/environment';
import { Utils } from '../../../shared/utils/utils';

@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.scss']
})
export class QuotationComponent implements OnInit, OnChanges {

  @Input() textListInfo: any[] = [];
  @Input() data: any;
  @Input() aliasProducto: string = '';

  @Output() complete = new EventEmitter<void>();

  textList?: any[] = [];
  dataPrice?: any[] = [];
  isDesktopScreen: boolean = false;
  idCotizacion: string;
  uidGestionURL: string;
  cotizacionData: any = [];
  person: Persona = new Persona;
  titleText: string = "";
  titleSectionInfo: string = "";
  titleCoverageInfo: string = "Ver coberturas";
  imageUrl: string = '';
  destroy$ = new Subject<void>();
  totalPriceBig: ITotalPriceResume = {
    isXsell: true,
    isSmallCard: false,
    isMediumCard: false,
    isCenteredCard: false,
    annualPrice: 0,
    monthlyPrice: 0,
    translateKey: "shared.totalPriceResumeComponentXsell"
  };

  constructor(
    private screenDeviceService: ScreenDeviceService,
    private dialog: MatDialog,
    private analyticsService: AnalyticsService,
  ) { }

  ngOnInit(): void {
    this.analyticsService.resetDataLayer();
    this.checkScreen();
    this.getTitleAndSubtitleByProduct(this.aliasProducto);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['textListInfo'] && changes['textListInfo'].currentValue) {
      this.textList = changes['textListInfo'].currentValue;
    }

    if (changes['data'] && changes['data'].currentValue) {
      this.dataPrice = changes['data'].currentValue;
      this.totalPriceBig.annualPrice = this.data.anual;
      this.policySummaryCreation();
    }
  }

  nextStep() {
    this.set_initial_analytics_config('click-button:lo quiero', 'SalesP1');
    this.analyticsService.startEventWithCallback('SalesP1', () => {
      this.complete.emit();
    });
  }

  checkScreen() {
    this.screenDeviceService.checkScreenSize()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: any) => {
        this.isDesktopScreen = result.matches;
      });
  }

  openMobilepModal() {
    this.set_initial_analytics_config('click-boton:main-body:ver coberturas', 'verCoberturas');
    this.analyticsService.startEventWithCallback('verCoberturas', () => {
      this.dialog.open(CoverageModalBaseComponent, {
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        data: {
          coverageList: {
            alias: 'InfCob1Det1',
            aliasProduct: this.aliasProducto
          },
          coverageDet: {
            alias: 'InfCob1Det2',
            aliasProduct: this.aliasProducto
          }
        },
        panelClass: 'custom-mat-dialog'
      });
    });

  }

  openDesktopModal() {
    this.set_initial_analytics_config('click-boton:main-body:ver coberturas', 'verCoberturas');
    this.analyticsService.startEventWithCallback('verCoberturas', () => {
      this.dialog.open(CoverageModalBaseComponent, {
        width: '44%',
        height: '98vh',
        data: {
          coverageList: {
            alias: 'InfCob1Det1',
            aliasProduct: this.aliasProducto
          },
          coverageDet: {
            alias: 'InfCob1Det2',
            aliasProduct: this.aliasProducto
          }
        },
        panelClass: 'custom-mat-dialog'
      });
    });

  }

  getTitleAndSubtitleByProduct(aliasProducto: string) {
    const alias = aliasProducto.toLowerCase();

    switch (alias) {
      case 'noasistanual':
        this.titleText = 'Seguro de cancelación de entradas anual';
        this.titleSectionInfo = 'Cancela tus entradas y recibe tu dinero de vuelta en minutos';
        this.imageUrl = 'assets/img/1080x1080_hero_pag_exp.jpg';
        break;

      case 'noasistviajeanual':
        this.titleText = 'Seguro de cancelación de viajes anual';
        this.titleSectionInfo = 'Cancela tus viajes y recupera tu dinero en minutos';
        this.imageUrl = 'assets/img/1080x1080_experiencias_turismo.jpg';
        break;
    }
  }

  policySummaryCreation() {
    const annualPrice = this.totalPriceBig?.annualPrice;

    if (annualPrice === undefined || annualPrice === null) {
      return;
    }

    const expiration = new Date();
    expiration.setFullYear(expiration.getFullYear() + 1);

    const formattedExpiration = expiration.toLocaleDateString('es-ES');

    const formattedPrice =
      annualPrice.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + '€';

    const productDescription = sessionStorage.getItem('productDescription') ?? '';

    const policySummary = {
      price: formattedPrice,
      product: productDescription,
      expirationDate: formattedExpiration
    };

    sessionStorage.setItem('policySummary', JSON.stringify(policySummary));
    this.set_initial_analytics_config('', 'imPageview');
    this.analyticsService.startEventWithCallback('imPageview', () => { });
  }

  /**
    * Set all the analytics' related info for the current component
  */
  private set_initial_analytics_config(categoryActionLabel: string, eventName: string): void {
    this.analyticsService.resetDataLayer();
    const productAnalytics = this.getAnalyticsProductData(this.aliasProducto);
    /* ===================== */
    /* PAGE DATA */
    /* ===================== */
    this.analyticsService.setPhysicalUrl(environment.baseUrl + this.aliasProducto);
    this.analyticsService.setPageName('app_cotizador:area_publica:sales');
    this.analyticsService.setPageContentType('cotizador');
    this.analyticsService.setPageDigitalChannel('app_cotizador');
    this.analyticsService.setPageSection('area_publica');
    this.analyticsService.setPageLanguage('es');
    this.analyticsService.setCategoryActionLabel('');
    this.analyticsService.setNivel1('sales');
    this.analyticsService.setNivel2('addAccessoriesSelection');

    /* ===================== */
    /* PROCESS DATA */
    /* ===================== */
    this.analyticsService.setProcessStep('1');
    this.analyticsService.setProcessType('sales');
    this.analyticsService.setProcessName('quotation_addAccessoriesSelection');
    this.analyticsService.setProcessStatus('iniciado');

    /* ===================== */
    /* USER DATA */
    /* ===================== */
    this.analyticsService.setUserStatus('no_logado');
    this.analyticsService.setUserLang('es');

    const userBirth = sessionStorage.getItem('userBirth') ?? '';
    this.analyticsService.setUserBirth(userBirth);
    this.analyticsService.setUserResidence('VERDADERO');

    /* ===================== */
    /* PRODUCT DATA (DINÁMICO) */
    /* ===================== */

    this.analyticsService.setCategoryActionLabel(categoryActionLabel)
    this.analyticsService.setProductName(Utils.sanitizeString(productAnalytics.productName));
    this.analyticsService.setProductType(Utils.sanitizeString(productAnalytics.productType));
    this.analyticsService.setProductArea(productAnalytics.productArea);
    this.analyticsService.setProductDate(Utils.getProductDate());

    const productCostStart = Number(this.totalPriceBig.annualPrice ?? 0);
    const productCostUpgrades = Number(this.totalPriceBig.annualPrice ?? 0);
    this.analyticsService.setProductCostStart(productCostStart);
    this.analyticsService.setProductCostUpgrades(productCostUpgrades);

    this.saveAnalyticsDataToSession();
  }

  private saveAnalyticsDataToSession(): void {
    const productAnalytics = this.getAnalyticsProductData(this.aliasProducto);
    const productCostStart = Number(this.totalPriceBig.annualPrice ?? 0);
    const productCostUpgrades = Number(this.totalPriceBig.annualPrice ?? 0);

    const analyticsData = {
      aliasProducto: this.aliasProducto,
      productName: productAnalytics.productName ?? '',
      productType: productAnalytics.productType ?? '',
      productArea: productAnalytics.productArea ?? '',
      productCostStart: Number(productCostStart ?? 0),
      productCostUpgrades: Number(productCostUpgrades ?? 0),
      userBirth: sessionStorage.getItem('userBirth') ?? '',
      idPoliza: 0,
    };

    sessionStorage.setItem('analyticsData', JSON.stringify(analyticsData));
  }

  private getAnalyticsProductData(aliasProducto: string) {
    switch (aliasProducto.toLowerCase()) {
      case 'noasistanual':
        return {
          productName: 'no asistencia anual',
          productType: 'no asistencia anual',
          productArea: 'Experiencias'
        };
      case 'noasistviajeanual':
        return {
          productName: 'cancelacion de viajes',
          productType: 'cancelacion de viajes',
          productArea: 'Experiencias'
        };
      default:
        return {
          productName: '',
          productType: '',
          productArea: ''
        };
    }
  }
}
